import { DEFAULT_PAGINATION_LIMIT } from "../../../../../globalConstants";

import { ERROR_FETCHING_DOCUMENTS } from "./strings";

export async function loadDocumentData({
  documentRepository,
  caseRepository = null,
  caseId = null,
  searchParams = {},
}) {
  try {
    const _case = caseId && caseRepository ? await caseRepository.findRecord(caseId) : null;

    const documentsOpts = await documentRepository.getOptions();
    const deleteDocument = async (docId) => await documentRepository.delete(docId);
    const patchDocument = async (docId, body) => await documentRepository.patch(docId, body);

    const fetchDocuments = async (page = 1) => {
      const offset = DEFAULT_PAGINATION_LIMIT * (page - 1);
      const queryParams = {
        ...searchParams,
        limit: DEFAULT_PAGINATION_LIMIT,
        offset,
        ordering: searchParams.ordering || "-created_at",
        ...(caseId && _case ? { case: _case.id } : {}),
      };

      return await documentRepository.query(queryParams);
    };

    const documents = await fetchDocuments(1);
    const count = await documentRepository.getTotalCount();
    const raw_data= await documentRepository.getRawData()
    return {
      _case,
      documentsOpts,
      deleteDocument,
      patchDocument,
      fetchDocuments,
      documents,
      count,
      raw_data,
    };
  } catch {
    return {
      message: ERROR_FETCHING_DOCUMENTS,
    };
  }
}
